import { post, postJson, url_domain, url_pre, get } from "@/plugins/api"
import { getUrlStringFromParams } from '@/plugins/utils/tools'

export function getUsdtAddress(params) {
    return new Promise((resolve, reject) => {
        get(`${url_domain()}${url_pre()}/wallet/usdt/get_address?symbol=${params.symbol || 'USDT'}`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}


export function getCreditBuyCoinUrl(params) {
    return new Promise((resolve, reject) => {
        get(`${url_domain()}${url_pre()}/wallet/usdt/get_credit_buy_coin_url?symbol=${params.symbol || 'USDT'}`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}



export function getWithdrawList(params) {
    return new Promise((resolve, reject) => {
        get(`${url_domain()}${url_pre()}/wallet/withdraw/record?${getUrlStringFromParams(params)}`)
            .then(res => {
                resolve(res.data || res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function getERCUsdtAddress(params) {
    return new Promise((resolve, reject) => {
        get(`${url_domain()}${url_pre()}/wallet/usdt/get_address_erc2`, params)
            .then(res => {
                resolve(res.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
} export function getTRCUsdtAddress(params) {
    return new Promise((resolve, reject) => {
        get(`${url_domain()}${url_pre()}/wallet/usdt/get_address?symbol=TRX`, params)
            .then(res => {
                resolve(res.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function withdraw(params) {
    return new Promise((resolve, reject) => {
        postJson(`${url_domain()}${url_pre()}/wallet/withdraw`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
